<template>
  <teleport to="body">
    <div v-if="show" @click="tryClose" class="backdrop"></div>
    <transition name="dialog">
      <dialog open v-if="show" :class="{mobile_dialog:isMobile}">
        <header>
          <slot name="header">
            <h2>환불신청</h2>
          </slot>
        </header>
        <template v-if="selcomp=='itemUse'">
          <section>
            <slot></slot>
            <div class="item_title">
              <h1>{{getCurrent.item_title}}</h1>
              <span>사용갯수를 선택해 주세요</span>
            </div>
            <div class="counter_part">
              <counter :max='getCurrent.remain' @getcount="test($event)">사용갯수 선택</counter>
              <div v-if="getCurrent.item_point>0" class="givepoint">지급 포인트 : <strong>{{addComma(getCurrent.item_point * count)}}</strong></div>
            </div>
          </section>
          <menu v-if="!fixed">
            <slot name="actions">
              <div class="btn"><base-button-sm mode='orange' @click="itemUse">사용하기</base-button-sm></div>
              <div class="btn"><base-button-sm mode='darkblue' @click="tryClose">취소</base-button-sm></div>
            </slot>
          </menu>
        </template>
        <template v-if="selcomp=='refund'">
          <section>
            <slot></slot>
            <div class="item_title">
              <h1>{{getCurrent.item_title}}</h1>
              <div class="refund_price">환불액 
                <div><span>{{addComma(getCurrent.item_price * getCurrent.count *0.8)}}</span> 원</div>
              </div>
              <div  class="caution">환불 정책에 따라 상품금액의 <strong>20%</strong> 공제된 금액이 입금됩니다.</div>                 
            </div>
            <div class="counter_part inputbank">                 
              <div class="bankinfo">                
                <input type="text" v-model.trim="user_name.val" placeholder="예금주" 
                @blur="word_e_k_n($event,'','user_name'),clearValidity('user_name')">
                <select v-model="bank_name.val" @blur="clearValidity('bank_name')">
                    <option value="">-은행선택-</option>
                    <option
                        v-for="(bank,index) in banklists"
                        :key="index"
                        :value="`${bank}`"
                    >
                        {{ bank }}
                    </option>
                </select>
                <input type="text" v-model.trim="bank_num.val" placeholder="계좌번호" 
                @blur="word_n($event,'','bank_num'),clearValidity('bank_num')">
              </div>
              <div v-if="!formIsValid" class="alert-valid">              
                <div><span class="ic_alert"></span></div>
                <div class="text">
                  은행정보를 정확히 입력해 주세요
                </div>
              </div>
             
            </div>
          </section>
          <menu>
            <slot name="actions">
              <div class="btn"><base-button-sm mode='orange' @click="refund">환불신청</base-button-sm></div>
              <div class="btn"><base-button-sm mode='darkblue' @click="tryClose">취소</base-button-sm></div>
            </slot>
          </menu>
        </template>
      </dialog>
    </transition>
  </teleport>
</template>

<script>
import Counter from './counter.vue'
import { auth } from '@/components/mixins/auth.js';
import { comma } from '@/components/mixins/comma.js';
import { banklists } from '@/components/mixins/banklists.js';
import { ckWord } from '@/components/mixins/ckWord.js';
export default {
  name:'itempop',
  mixins:[ auth,comma,banklists,ckWord],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    fixed: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemId:{
      //type: Number,
      required: true,
      default: false,
    },
    selcomp: {
      type: String,
      required: true,
    },    
    isMobile:{
      default:false
    }
  },
  data(){
    return {
      count:1,
      item:'',
      user_name:{val:'',isValid:true, wordValid:false},
      bank_name:{val:'',isValid:true, wordValid:true},
      bank_num:{val:'',isValid:true, wordValid:false},
      formIsValid:true,     
    }
  },
  components:{
    Counter
  },
  computed:{
    getCurrent(){
      return this.$store.getters["item/getMyItems"].data.find( (item) => item.id === this.itemId )
    },
  },
  emits: ["close"],
  methods: {
    
    test(e){
      this.count = e;
    },
    tryClose() {
      if (this.fixed) {
        return;
      }
      this.count = 1;
      this.bankinit()
      this.$emit("close");
    },
    async itemUse(){
        if(this.authCheck() !==true)
        {
            return
        }
        //입력값 체크
        const formData = {
            itemBuyId:this.getCurrent.id,
            count:this.count,
        }
        try {
            const response = await this.$store.dispatch("item/itemUse", formData)
            console.log(response);
            if(response.itemUse)
            {
              this.$store.commit('updateUserPoint',response.user);
              if(response.levelchange)
              {
                  alert('레벨이 변경되었습니다.');
              }
            }
            this.$flashMessage.show({
                type: response.itemUse===false?"error":"info",
                title: response.message,
                message: response.message,
            });

        }catch(error){
            console.log(error);
        }
        this.$emit("close");
    },
    clearValidity(input) {
      if(this[input].val !=='' && this[input].wordValid===true)
      {
        this[input].isValid = true;
      }else{
        this[input].isValid = false; 
      }      
      //alert(this[input].isValid)
      if(this.user_name.isValid===true && this.bank_name.isValid===true && this.bank_num.isValid===true)
      {
        this.formIsValid =true;       
      }else{
        this.formIsValid =false;        
      }
    },
    validateForm() {
      this.formIsValid = true;
      //예금주체크
      if (this.user_name.val === '' || this.user_name.wordValid === false)
      {        
        this.formIsValid = false;
      }
      //은행명
      if (this.bank_name.val === '' )
      {        
        this.formIsValid = false;
      }
      //계좌번호
      if (this.bank_num.val === '' || this.bank_num.wordValid === false)
      {        
        this.formIsValid = false;
      }
      
    },
    async refund(){
        if(this.authCheck() !==true)
        {
            return
        }       
        this.validateForm();
        if (!this.formIsValid) {
          return;
        }
        const formData = {
            itemBuyId:this.getCurrent.id,
            user_id:this.user.id,
            user_name:this.user_name.val,
            bank_name:this.bank_name.val,
            bank_num:this.bank_num.val,               
        }
        try {
            const response = await this.$store.dispatch("item/reqRefund", formData)
            console.log(response);
            
            this.$flashMessage.show({
                type: response.refund===false?"error":"info",
                title: response.message,
                message: response.message,
            });
            this.bankinit()
            this.$emit("close");
        }catch(error){
            console.log(error);
        }
        
    }, 
    bankinit(){
        this.user_name.val='';
        this.bank_name.val='';
        this.bank_num.val=''; 
        this.formIsValid =true;       
    }   
    // getItem(){
    //     //this.$store.state.item.itemBuy
    //     this.item = this.$store.getters["item/getMyItems"].data.find( (item) => item.id === this.itemId );
    //     //console.log('내 아이템',this.$store.getters["item/getMyItems"].data)
    // }
  },
};
</script>

<style lang="scss" scoped>
.mobile_dialog{
  width:90% !important;
  left: 5%;
  top: 10vh;
  .bankinfo{
    flex-flow: column;    
    input:first-child{width:100% !important;margin-right:0;margin-bottom: 10px;}
    input:nth-child(2){width:100%;}
    input:nth-child(3){width:100% !important;margin-left:0 !important ; ;margin-top: 10px;}
  }
  .btn {
    width:40%;padding:0 10px;
    height:30px;
  }
}
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

dialog {
  position: fixed;
  top: 30vh;
  left: 10%;
  width: 80%;
  z-index: 100;
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-color: white;
  font-family: tahoma,helvetica,"\B098\B214\ACE0\B515","Nanum Gothic","\B098\B214\C2A4\D018\C5B4","Nanum Square","Apple SD Gothic Neo","Malgun Gothic","\B9D1\C740\ACE0\B515",dotum,"\B3CB\C6C0",sans-serif;

}

header {
  background-color: #3a0061;
  color: white;
  width: 100%;
  padding: 1rem;
}

header h2 {
  margin: 0;
}

section {
  padding: 1rem;
}
.item_title{
  text-align:center;
  
  .refund_price{
    display:flex;
    flex-direction:column;
     background:#eee;
      padding:5px 30px;
      border-radius:5px;
    span{
      font-size:30px;
      display:inline-block;
     
    }
    
  }
}

.counter_part{
  border-top:1px solid #dee3eb;
  border-bottom:1px solid #dee3eb;
}
.inputbank{  
  justify-content:center;
  padding:20px 0;
  margin-top:10px;
  display:flex;
  flex-direction:column;
  text-align:center;
  span{
    padding-bottom:10px;
  }
  .bankinfo{   
    display:flex;
    justify-content:center;
    input, select{
        padding:0 20px;
        border: 1px solid #dadada;
        font-size: 12px;                    
        line-height:30px;
        height:30px;
    }
    input:first-child{width:20%;margin-right:10px}
    input:nth-child(2){width:30%;}
    input:nth-child(3){width:50%;margin-left:10px}
  }
  .alert-valid{
    display:flex;
    justify-content:center;
    margin-top:5px;    
  }
 
}
menu {
  padding: 1rem;
  display: flex;
  justify-content: center;
  margin: 0;

}
.btn {
  width:20%;padding:0 10px;
  height:30px;
}
.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.dialog-enter-active {
  transition: all 0.3s ease-out;
}

.dialog-leave-active {
  transition: all 0.3s ease-in;
}

.dialog-enter-to,
.dialog-leave-from {
  opacity: 1;
  transform: scale(1);
}
.givepoint{
  text-align:center;
}
.givepoint strong{
  font-size:20px;
}
@media (min-width: 768px) {
  dialog {
    left: calc(50% - 20rem);
    width: 40rem;
  }
}
</style>
